import { Component, OnInit } from '@angular/core';
import { EnvironmentEnum } from 'app/core/enums/environment-enum';
import { Globals } from 'app/globals';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styles: []
})
export class DashboardComponent implements OnInit {

  public get isBetaEnvironment(): boolean {
    return this.globals.getEnvironment() === EnvironmentEnum.Beta;
  }

  constructor(private globals: Globals) { 
  }

  ngOnInit() {
  }

}
